<template>
    <div @click="emit && $emit(emit)">
        <i v-if="variant === ArrowVariantEnum.THICK"
           class="fa-solid fa-angle-right"
           :style="{ transform: `rotate(${rotateDegree}deg)`, width: width, height: height }" />
        <svg v-else-if="variant === ArrowVariantEnum.THIN"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 24 24"
             :width="width"
             :height="height"
             fill="none"
             stroke="#000000"
             stroke-width="1"
             stroke-linecap="butt"
             stroke-linejoin="arcs"
             :style="{ transform: `rotate(${rotateDegree}deg)` }">
            <path d="M9 18l6-6-6-6" />
        </svg>
        <svg v-else-if="variant === ArrowVariantEnum.NORMAL"
             xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 320 512"
             :width="width"
             :height="height"
             class="cursor-pointer"
             :style="{ transform: `rotate(${rotateDegree}deg)` }">
            <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" />
        </svg>
    </div>
</template>

<script setup lang="ts">
    import { ref, watchEffect } from 'vue';
    import { DirectionsEnum } from '@/js/enums/directions';
    import { ArrowVariantEnum } from '@/js/types/arrowVariants';

    interface IProps {
        height?: string,
        width?: string,
        emit?: string,
        direction?: DirectionsEnum,
        variant?: ArrowVariantEnum,
    }

    const props = withDefaults(defineProps<IProps>(), {
        height: '16',
        width: '14',
        emit: '',
        direction: DirectionsEnum.RIGHT,
        variant: ArrowVariantEnum.NORMAL,
    });

    const rotateDegree = ref('0');

    const calculateDirection = () => {
        switch (props.direction) {
        case DirectionsEnum.UP:
            rotateDegree.value = '270';
            break;
        case DirectionsEnum.DOWN:
            rotateDegree.value = '90';
            break;
        case DirectionsEnum.LEFT:
            rotateDegree.value = '180';
            break;
        default:
            rotateDegree.value = '0';
            break;
        }
    };

    watchEffect(() => props.direction && calculateDirection());
</script>

<style scoped lang="scss">
svg,
i {
    transition: transform 150ms ease-in-out;
}
</style>
